import React from 'react'
import { readableDate } from '../common/set_date';
import DashUserDiscussionTopics from '../DiscussionRoom/Feed/DashUserDiscussionTopics';
import DashTrendingDebates from '../DebateRoom/DashTrendingDebates';
import { GoThumbsdown, GoThumbsup } from 'react-icons/go';
import { Link } from 'react-router-dom';

function ActivityItemData({data}) {
    const dateObject = readableDate(data.date_created);

    if (data?.voting_status) {
        return <div className='sm:px-5 py-1 my-3 border-b-[0.5px] border-gray-500' key={data.eid}>
                <DashUserDiscussionTopics item={data} date={dateObject} />
            </div>

    }else if (data?.debate_id) {
        return <div className='sm:px-5 my-3 border-b-[0.5px] border-gray-500' key={data.debate_id}>
                <DashTrendingDebates debaters={data} />
            </div>

    }else{
        const linkTo = data?.debate ? `/debates/${data.debate}`
        :
        data?.post ? `/discussions/${data.post}`
        :
        `/dashboard/${data.post}`;

        return (
        <Link to={linkTo} key={data.eid}>
        <div className='flex flex-col px-2.5 my-4 border-b-[0.5px] border-gray-500'>
            <div className='flex'>
                <div className="h-[50px] w-[50px]">
                    <img
                        src={data?.author?.user_image}
                        alt="User Avatar"
                        className="w-full h-full rounded-full"
                    />
                </div>
                <div className='mx-3 w-[85%]'>
                    <p className='text-[10px]'>{dateObject}</p>
                    <p className='my-1'>{data.text}</p>
                </div>
            </div>
            <div className='flex justify-end m-3'>
                <div className='flex space-x-4'>
                    <p>
                        {data.upvote_count}
                        <GoThumbsup className='mx-1 inline' />
                    </p>
                    <p>
                        {data.downvote_count}
                        <GoThumbsdown className='mx-1 inline' />
                    </p>
                </div>
                <div className='justify-end ml-2'>
                    <div
                        to={linkTo}
                        className='bg-updatedPurple px-3 py-1 hover:bg-[#767cb9]'
                    >
                        Go to comment
                    </div>
                </div>
            </div>
        </div>
        </Link>
        );
    }
}

export default ActivityItemData
